import { employerHubApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';

import { TanstackTableSearchParamsAdapter } from '@itm/shared-frontend/lib/utils';

import {
  AssignDirectDebitToPayrollsModel,
  CreateDirectDebitModel,
  DirectDebitContactDetailsResponse,
  DirectDebitResponse,
  DirectDebitResponsePagedResponse,
  ShortDirectDebitResponse,
  ShortPayrollResponsePagedResponse,
} from 'src/types';

export const getDirectDebitDetailsByEmployerId = (
  companyId: string,
  employerId: string,
  config: AxiosRequestConfig = {},
) =>
  employerHubApi.get<ShortDirectDebitResponse[]>(
    `/api/v1/companies/${companyId}/employers/${employerId}/direct-debits`,
    config,
  );

export const getDirectDebitContactDetails = (companyId: string, config: AxiosRequestConfig = {}) =>
  employerHubApi.get<DirectDebitContactDetailsResponse>(
    `/api/v1/companies/${companyId}/direct-debits/contact-details`,
    config,
  );

export const getThirdPartyAndAdminSyncPermissionForEmployer = (
  companyId: string,
  employerId: string,
  config: AxiosRequestConfig = {},
) =>
  employerHubApi.get<string>(
    `/api/v1/companies/${companyId}/employers/${employerId}/admin-sync-third-party-permission`,
    config,
  );

export const getShortDirectDebitDetailsById = (
  companyId: string,
  directDebitId: string,
  config: AxiosRequestConfig = {},
) =>
  employerHubApi.get<ShortDirectDebitResponse>(`/api/v1/companies/${companyId}/direct-debits/${directDebitId}`, config);

export type AssignedPayrollToDirectDebitListSearchParams = TanstackTableSearchParamsAdapter & {
  directDebitId: string;
};

export const getAssignedPayrollToDirectDebitListSearch = (
  companyId: string,
  params: AssignedPayrollToDirectDebitListSearchParams,
  config: AxiosRequestConfig = {},
) =>
  employerHubApi.get<ShortPayrollResponsePagedResponse>(`/api/v1/companies/${companyId}/direct-debits/payrolls`, {
    ...config,
    params,
  });

export const createDirectDebit = (companyId: string, data: CreateDirectDebitModel, config: AxiosRequestConfig = {}) =>
  employerHubApi.post<string>(`/api/v1/companies/${companyId}/direct-debits`, data, config);

export const assignDirectDebitToPayroll = (
  companyId: string,
  data: AssignDirectDebitToPayrollsModel,
  config: AxiosRequestConfig = {},
) => employerHubApi.patch<string>(`/api/v1/companies/${companyId}/direct-debits/assign-payrolls`, data, config);

export const getDirectDebitDetailsByPayrollId = (
  companyId: string,
  payrollId: string,
  config: AxiosRequestConfig = {},
) =>
  employerHubApi.get<DirectDebitResponse>(`/api/v1/companies/${companyId}/payroll/${payrollId}/direct-debit`, config);

export type GetDirectDebitHistoryListSearchParams = TanstackTableSearchParamsAdapter & {
  payrollId: string;
};

export const getDirectDebitHistoryListSearch = (
  companyId: string,
  params: GetDirectDebitHistoryListSearchParams,
  config: AxiosRequestConfig = {},
) =>
  employerHubApi.get<DirectDebitResponsePagedResponse>(`/api/v1/companies/${companyId}/payroll-direct-debit-history`, {
    ...config,
    params,
  });
